import { apiFetch } from './http';

export function getClients() {
  return apiFetch('/api/clients');
}

export function getClient(id) {
  return apiFetch(`/api/clients/${id}`);
}

/**
 * Stripe billing-portal redirect (T9.9). The backend creates the portal
 * session (Stripe customer portal API) and returns { url }; the SPA just
 * forwards the browser. The portal never mutates subscriptions itself —
 * Stripe owns plan changes (supports the no-config guarantee, T9.10).
 */
export async function openBillingPortal(tenantId) {
  const response = await apiFetch('/api/clients/me/billing-portal', {
    body: JSON.stringify({ tenantId, returnPath: `${window.location.pathname}#/client/billing` }),
    method: 'POST'
  });
  if (response?.url) {
    window.location.assign(response.url);
  }
  return response;
}
